"use client";
import * as React from "react";

export function MissionSection() {
  return (
    <section className="relative py-24 px-6">
      <div className="mission-wrapper flex gap-16 items-center mx-auto my-0 max-w-[1344px] w-full max-md:flex-col">
        <div className="h-[400px] w-[400px] max-md:h-[300px] max-md:w-[300px]">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/603f291f13ddb56acec4bba0b0dd98928fe3889d?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            className="object-contain w-full aspect-[0.99] max-md:mt-10 max-md:max-w-full"
            alt="Mission illustration"
          />
        </div>
        <div className="flex flex-col flex-1 gap-6">
          <h2 className="text-5xl font-bold text-white leading-[56px] max-sm:text-4xl max-sm:leading-10 font-fredoka">
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
              Mission
            </span>
          </h2>
          <p className="text-2xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
            We believe that learning should be magical, engaging, and
            accessible to every child. Our mission is to create innovative
            AI-powered toys and educational tools that inspire creativity,
            foster learning, and bring families together through the wonder of
            technology and imagination.
          </p>
          <button className="mission-button bg-pink-500 text-white px-6 py-3 rounded-xl mt-12 max-w-fit">
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
}
